<script>
  import { fly } from "svelte/transition";

  export let open = false;
</script>

{#if open}
  <div transition:fly|local={{ x: 20 }} class="side_wrapper">
    <div class="button_wrapper">
      <slot name="header" />
    </div>
    <div class="container">
      <slot name="container" />
    </div>
    <div class="button_wrapper">
      <slot name="footer" />
    </div>
  </div>
{/if}

<style>
  .side_wrapper {
    position: fixed;
    right: 0;
    top: 4rem;
    z-index: 20;
    width: 30rem;
    height: calc(100vh - 4rem);
    background-color: var(--pax-white);
    color: var(--pax-black);
    padding: 1rem;
    border-left: 1px solid #d9d9d9;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .side_wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: -0.3rem;
    width: 0.3rem;
    background: linear-gradient(to left, #d9d9d9, transparent);
  }

  .container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    /* max-width: 331px; */
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100% - 8rem);
    min-width: 0;
  }

  .button_wrapper {
    display: flex;
    gap: 0.5rem;
    overflow: hidden;
    min-width: 0;
    width: 100%;
  }
</style>
